import React from "react";
import {
  translateService,
  workSpacesService,
  stateService,
  mediaService,
  htmlHelperService,
  dateHelperService,
  authService,
  routingService,
  commonService,
  signService,
  sessionService,
} from "../../services/imports";
import {
  createValidationContext,
  Input,
  LoadingButton,
} from "../../components/formcontrols/imports";
import FileDrop from "../../components/fileDrop";
import OptimizedComponent from "../../components/optimizedComponent";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { states, stateEvents } from "../../models/states";
import { Scrollbars } from "react-custom-scrollbars";
import ResultPage from "../viewResult/resultPage";
import { defaults } from "../../models/imports";
import ContactPage from "../contact/contact";
import TermsPage from "../terms/terms";
import PackageInfo from "../package-info/package-info";
import SignaturePage from "../signature/signature";
import ShareDialog from "../../components/share/shareDialog";
import OrganizationPicker from "../../components/organizationPicker";
import { EID_KIND } from "../viewResult/signingMethods";
import { takePendingModal } from "../../services/dashboardModal";
import {AppContext} from './../../Context/AppContext';

export default class dashboardPage extends OptimizedComponent {
  constructor() {
    super();

    this.state = {
      doc: {},
      documents: [],
      documentResult: null,
      workSpaceId: null,
      shareModal: false,
      documentName: null,
      shareId: null,
      deleteModal: false,
      viewDocId: null,
      required: false,
      isValidationLoading: false,
      isSignatureLoading: false,
      deleteLoading: false,
      deleteionId: null,
      nextPayDate: null,
      listTimestamps: [],
      hasScroll: false,
      doclinkvalid: false,
      modalPageType: null,
      openedPages: [],
      documentIsProcessing: false,
      pendingFree: [],
      pendingOpen: true,
    };

    this.isFirstLoad = true;
    this.urlValidation = createValidationContext();
    this.docValidation = createValidationContext();
    this.scrollService = htmlHelperService.createScrollPaging();
  }

  static contextType = AppContext;
  

  // the share dialog (share-prompt tasks 8-9): recipients, grants, and the
  // document's shares with their actions
  viewShareDialog = (docId, name) => {
    this.setState({ shareModal: true, shareId: docId, documentName: name });
  };

  viewDeleteDialog = (docId, name) => {
    this.setState({
      deleteModal: true,
      deleteionId: docId,
      documentName: name,
    });
  };

  delete = () => {
    this.setState({ deleteLoading: true });
    workSpacesService.deleteDocument(this.state.deleteionId).subscribe(
      (resp) => {
        if (resp.success) {
          this.setState((state) => {
            let s = { ...state, deleteLoading: false };
            s.deleteModal = false;
            s.documents = [
              ...state.documents.filter(
                (doc) => doc.docExposedId !== state.deleteionId
              ),
            ];
            s.deleteionId = null;
            return s;
          });
        }
      },
      () => {
        this.setState({ deleteLoading: false });
      }
    );
  };

  // docId: the document's exposed id (2026-10-13). view: open its page;
  // update: a val notification's re-read of a listed or open document
  getDocumentResult = (docId, update, view = true) => {
    this.secureSubscription(
      // v2 read; a notification's re-read (view false) is silent when refused.
      // Opening one: a 400 (an old numeric id from a bookmark, or no such
      // document) says "not found" in the app's words - Spring's own 400
      // quotes the request in English
      workSpacesService.getDocumentResult(docId, { skipCustomErrorHandling: true }).subscribe((res) => {
        const data = { data: res.data };
        if (data.data) {
          this.setState((prevState) => {
            let state = { ...prevState };

            //only view result
            if (view) {
              state.documentResult = data.data;
              state.viewDocId = docId;
              let pages = state.openedPages;
              pages = pages.filter(
                (page) => page.name != routingService.routeNames.viewResult
              );
              pages = [
                { name: routingService.routeNames.viewResult },
                ...pages,
              ];
              state.openedPages = pages;
              return state;
            }

            //when subscription result is VAL
            if (!view && update) {
              let docIndex = state.documents.findIndex(
                (doc) => doc.docExposedId === docId
              );
              if (docIndex >= 0) {
                state.documents[docIndex] = data.data;
              } else {
                state.documents = [data.data, ...state.documents];
              }

              //if this document's page is opened
              if (this.state.viewDocId === docId) {
                state.documentResult = data.data;
              }
              return state;
            }
          });
        }
      }, (e) => {
        if (!view) return;
        const status = e && e.response && e.response.status;
        stateService.event(
          stateEvents.globalError,
          status === 400
            ? translateService.t("document.notFound")
            : signService.problemMessage(e, translateService.t("error.error"))
        );
      })
    );
  };

  closeDocumenResult = () => {
    this.setState((prevState) => {
      let state = { ...prevState };
      state.viewDocId = null;
      let pages = state.openedPages;
      pages = pages.filter(
        (page) => page.name != routingService.routeNames.viewResult
      );
      state.openedPages = pages;
      return state;
    });

    if (this.props?.match?.params?.docId) {
      this.getDocuments();
    }
    this.loadPending();
  };

  // Free validations the person requested through the public form and never
  // opened (share-prompt task 22): in their main workspace, yet in no list
  // until opened; opening one starts its validation (the document page)
  loadPending = () => {
    if (!authService.isActive() || this.needsOrganization()) return;
    this.secureSubscription(
      workSpacesService.getPendingFreeValidations().subscribe(
        (res) => this.setState({ pendingFree: (res.data && res.data.items) || [] }),
        () => this.setState({ pendingFree: [] })
      )
    );
  };

  openPending = (item) => {
    this.setState((s) => ({ pendingFree: s.pendingFree.filter((p) => p.docExposedId !== item.docExposedId) }));
    this.getDocumentResult(item.docExposedId);
  };

  renderPending() {
    const t = (k, ...a) => translateService.t(`dashboard.${k}`, ...a);
    const items = this.state.pendingFree.filter((p) => p.workspaceExposedId === this.state.workSpaceId);
    if (!items.length) return null;
    const open = this.state.pendingOpen;
    return (
      <section className={`pending-free ${translateService.key}`}>
        <button
          type="button"
          className="pending-free__toggle"
          aria-expanded={open}
          aria-controls="pending-free-list"
          onClick={() => this.setState({ pendingOpen: !open })}
        >
          <span>{t("pendingTitle", items.length)}</span>
          <span aria-hidden="true">{open ? "−" : "+"}</span>
        </button>
        {open && (
          <div id="pending-free-list">
            <p className="pending-free__hint">{t("pendingHint")}</p>
            <ul>
              {items.map((item) => (
                <li key={item.docExposedId}>
                  <span className="pending-free__name _3dots-1" title={item.fileName}>
                    {item.fileName}
                  </span>
                  <span className="pending-free__date nowrap">
                    {dateHelperService.format(item.requestedAt, dateHelperService.smallDateTimeFormat)}
                  </span>
                  <LoadingButton
                    type="button"
                    className="button background-color-two color-white"
                    onClick={() => this.openPending(item)}
                  >
                    {t("pendingOpen")}
                  </LoadingButton>
                </li>
              ))}
            </ul>
          </div>
        )}
      </section>
    );
  }

  // a chosen file (or link), else the field's error
  hasDocument = () => {
    let validUrl = this.urlValidation.removeCustomErrors().setDirty().isValid();

    if (!this.context.state.pdfData) this.setState({ required: true });
    let valid = this.docValidation.removeCustomErrors().setDirty().isValid();
    if (
      (!valid || !this.context.state.pdfData) &&
      (!validUrl || !this.context.state.pdfPath)
    ) {
      stateService.event(stateEvents.validateCheck, { check: true });
      return false;
    }
    return true;
  };

  // The upload: file or link, the active workspace. With sign, Georgian eID
  // follows as signature-gateway's process on the new document (share-prompt
  // task 12): the backend's own eID path is gone.
  validateDocument = (sign = false) => {
    if (!this.hasDocument()) return;
    const file = this.context.state.pdfData;
    const loadingKey = sign ? "isSignatureLoading" : "isValidationLoading";
    this.setState({ [loadingKey]: true, required: false });
    mediaService
      .privateUploadFile(file, this.context.state.pdfPath, this.state.workSpaceId)
      .subscribe(
        (res) => {
          const signData = { ...res.data };
          signData.signers = [translateService.t("dashboard.dataProcessing")];
          this.setState((prevState) => ({
            documents: [signData, ...prevState.documents],
            success: true,
            doclinkvalid: false,
            isValidationLoading: false,
          }));
          this.context.setState({ pdfData: null, pdfPath: "" });
          if (sign) this.startEidSigning(res.data, file);
        },
        () => this.setState({ [loadingKey]: false })
      );
  };

  // POST /process with the eID kind, the hash of the uploaded bytes in the
  // first algorithm signing-options allows, then the process page
  startEidSigning = async (doc, file) => {
    const fail = (message) => {
      stateService.event(stateEvents.globalError, message);
      this.setState({ isSignatureLoading: false });
    };
    const docId = doc && doc.docExposedId;
    if (!docId || !file) return fail(translateService.t("faceSign.startError"));
    let options;
    try {
      options = (await workSpacesService.getSigningOptions(docId, { skipCustomErrorHandling: true }).toPromise()).data;
    } catch (e) {
      return fail(signService.problemMessage(e, translateService.t("faceSign.startError")));
    }
    const algorithm = signService.pickHashAlgorithm(options && options.allowedClientHashAlgorithms);
    if (!algorithm) return fail(translateService.t("faceSign.noHashAlgorithm"));
    let clientHash;
    try {
      clientHash = await signService.digestHex(algorithm, await file.arrayBuffer());
    } catch (e) {
      return fail(translateService.t("faceSign.documentError"));
    }
    signService
      .createProcess({
        docId,
        workspaceId: doc.workspaceExposedId || this.state.workSpaceId,
        signerKind: EID_KIND,
        preferredAuthType: "EID",
        clientHash,
        clientHashAlgorithm: algorithm,
      })
      .subscribe(
        (res) => {
          this.setState({ isSignatureLoading: false });
          const processId = res.data && res.data.processId;
          if (!processId) return fail(translateService.t("faceSign.startError"));
          routingService.push(routingService.routeNames.signProcess, { params: { processId } });
        },
        (e) => fail(signService.problemMessage(e, translateService.t("faceSign.startError")))
      );
  };

  fileDrop = (file) => {
    this.setState((state) => {
      let temp = { ...state };
      if (file) {
        temp.required = false;
        (temp.doclinkvalid = false);
      }
      return temp;
    }, () => {
      if (file) {
        this.context.setState({pdfData: file[0], pdfPath: ''});
      }
    });
    
  };

  getDocuments = async () => {
    if (this.fetchFinished || this.fetchStarted) return;
    this.fetchStarted = true;

    this.secureSubscription(
      workSpacesService
        .getDocumentList(this.state.workSpaceId, this.state.postTime)
        .subscribe(
          (res) => {
            this.fetchStarted = false;
            if (!res.data) return;

            if (
              !this.state.listTimestamps.includes(this.state.postTime) &&
              this.state.postTime
            )
              this.state.listTimestamps.push(this.state.postTime);

            this.fetchFinished = !res.data.pdfList.length;
            this.setState(
              (state) => {
                let documents = [...state.documents, ...res.data.pdfList];
                let postTime = res.data.timeStamp;

                return {
                  documents,
                  postTime,
                  isFirstLoad: false,
                };
              },
              () => {
                if (
                  !this.scrollService.hasScollHeight(
                    this.docList?.container?.firstChild
                  )
                ) {
                  this.getDocuments();
                } else {
                  this.setState({ hasScroll: true });
                }
              }
            );
          },
          () => {
            this.fetchStarted = false;
          }
        )
    );
  };

  onScroll = (e) => {
    if (this.fetchStarted) return;
    this.scrollService.onScrollDown(e, this.getDocuments);
  };

  emptyFile = (e) => {
    e?.stopPropagation();
    this.setStateProperty({ "doc.userName": "" });
    this.context.setState({pdfData: null});
  };

  // a corporate (hrms) login works in its organizations' workspaces: with
  // none active it picks an organization first (share-prompt task 16)
  needsOrganization = () => this.state.workSpaceId == null && sessionService.isCorporate();

  getResultPageZIndex = () => {
    return this.state.openedPages.findIndex(
      (page) => page.name == routingService.routeNames.viewResult
    );
  };

  componentDidMount() {
    if (!authService.isActive()) routingService.navigate(defaults.notAuthRoute);

    this.secureSubscription(
      translateService.subscribe((_) => {
        this.context.setState({currentLang: translateService.key});
      })
    );

    if (this.props?.match?.params?.docId) {
      this.getDocumentResult(this.props?.match?.params?.docId);
    }

    this.secureSubscription(
      stateService.getState(states.userInfo).subscribe((data) => {
        this.context.setState({facsimile: data.facsimilePath});
        this.setState(
          {
            workSpaceId: data.workspaceExposedId,
            nextPayDate: data?.nextPayDate,
          },
          () => {
            if (!this.props?.match?.params?.docId && !this.needsOrganization()) this.getDocuments();
            this.loadPending();
          }
        );
      })
    );

    this.secureSubscription(
      stateService.onEvent(states.changeWorkSpace).subscribe((id) => this.reloadList(id))
    );

    this.secureSubscription(
      stateService.onEvent(stateEvents.openModalPage).subscribe((type) => {
        // asked for from another page (openDashboardModal): taken here
        if (type) takePendingModal();
        this.setState((prevState) => {
          let state = { ...prevState };
          state.modalPageType = type;
          let pages = state.openedPages;
          if (type) {
            pages = pages.filter((page) => page.name != type);
            pages = [{ name: type }, ...pages];
            state.openedPages = pages;
          } else {
            pages = pages.filter(
              (page) => page.name == routingService.routeNames.viewResult
            );
            state.openedPages = pages;
          }
          return state;
        });
      })
    );

    // a modal page another page asked for before the dashboard was open
    const pendingModal = takePendingModal();
    if (pendingModal) stateService.event(stateEvents.openModalPage, pendingModal);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.socketResponse &&
      !commonService.compareObjectValues(
        prevProps.socketResponse,
        this.props.socketResponse
      )
    ) {
      this.setState({ socketResponse: this.props.socketResponse }, () => {
        if (this.state.socketResponse.type == NotificationResponseTypes.SHARE) {
          // a share of the document changed for the caller (shared to them,
          // withdrawn, moved, declined): the list again from its first page
          this.reloadList();
        } else if (
          this.state.socketResponse.type == NotificationResponseTypes.VAL
        ) {
          this.setState({ documentIsProcessing: false });
          this.onValidated(this.state.socketResponse.objectid);
          // an opened free validation leaves the pending ones
          this.loadPending();
        } else if (
          this.state.socketResponse.type == NotificationResponseTypes.PROC
        ) {
          this.setState({ documentIsProcessing: true });
        }
      });
    }
  }

  // public-api's notifications name the document by its numeric id, the
  // one place a numeric id is still compared: a listed row or the open
  // document is read again by its exposed id; any other document (another
  // member's upload) is not read - the list starts over
  onValidated = (objectid) => {
    const row = this.state.documents.find((doc) => doc.docId == objectid);
    const open = this.state.viewDocId && this.state.documentResult;
    if (row && row.docExposedId) this.getDocumentResult(row.docExposedId, true, false);
    else if (open && open.docId == objectid && open.docExposedId)
      this.getDocumentResult(open.docExposedId, true, false);
    else this.reloadList();
  };

  // the active workspace's list from its first page (a workspace switch, a
  // share notification, an unknown document validated)
  reloadList = (workSpaceId = this.state.workSpaceId) => {
    this.fetchStarted = this.fetchFinished = false;
    this.setState(
      { workSpaceId, documents: [], postTime: 0, listTimestamps: [] },
      () => {
        if (!this.props?.match?.params?.docId && !this.needsOrganization()) {
          this.getDocuments();
          if (this.docList) this.docList.scrollTop(0);
        }
      }
    );
  };

  updateHeader(value) {
    this.setState((prevState) => {
      let state = { ...prevState };
      state.documentResult.header = value;
      let docIndex = state.documents.findIndex(
        (doc) => doc.docExposedId === state.documentResult.docExposedId
      );
      if (docIndex < 0) return { ...prevState };
      state.documents[docIndex].header = value;

      return { ...prevState, state };
    });
  }

  enterUrl = (e) => {
    this.urlValidation.removeCustomErrors().setDirty().isValid();

    this.setStateProperty({
      doclinkvalid: e.target.value.length > 0,
    });
    this.context.setState({pdfPath: e.target.value});
  };

  updateErrorInfo = async (e, onlyTarget = false) => {
    if (!onlyTarget) {
      htmlHelperService.pasteUrl(true).then((data) => {
        this.setStateProperty({
          doclinkvalid: data?.length > 0,
        });
        this.context.setState({pdfPath: data});
        let valid = this.urlValidation
          .removeCustomErrors()
          .setDirty()
          .isValid();
        if (!valid) return;
        this.emptyFile();
      });
      this.setState({ required: false });
    }

    !e.target.value && e.target.classList.add("tooltip-error");
  };

  componentWillUnmount() {
    this.clearSubscriptions();
  }

  listScroll = (e) => {
    this.onScroll(e);
  };

  render() {
    let concateNames = (elements = []) => {
      if (!elements) return "";
      let result = "";
      elements.forEach(
        (signer) => (result = result.concat(signer).concat(","))
      );
      return result.substr(0, result.length - 1);
    };

    return (
      <React.Fragment>
        {this.state.modalPageType &&
          (this.state.modalPageType === routingService.routeNames.contact ? (
            <ContactPage display={this.getResultPageZIndex() != 0} />
          ) : this.state.modalPageType === routingService.routeNames.terms ? (
            <TermsPage display={this.getResultPageZIndex() != 0} />
          ) : this.state.modalPageType ===
            routingService.routeNames.Settings ? (
            <PackageInfo display={this.getResultPageZIndex() != 0} />
          ) : this.state.modalPageType ===
            routingService.routeNames.signature ? (
            <SignaturePage display={this.getResultPageZIndex() != 0} />
          ) : null)}
        {this.state.viewDocId && (
          <ResultPage
            isPopup={true}
            display={this.getResultPageZIndex() == 0}
            onUpdateHeader={(value) => this.updateHeader(value)}
            fromRoute={this.props?.match?.params?.docId ? true : false}
            result={this.state.documentResult}
            goBack={this.closeDocumenResult}
          />
        )}

        <div
          className={`dashboard container ${translateService.key} ${
            this.state.modalPageType || this.state.viewDocId ? "d-none" : ""
          }`}
        >
          {this.needsOrganization() ? (
            <OrganizationPicker />
          ) : (
          <div className="dashboard-items">
            <div className="flex-title-item">
              <div className="file-container">
                <span className="uploadTitle">
                  {translateService.t("common.uploadOrPaste")}
                </span>
                <div className="inputs">
                  <div className="input-item file-choose">
                    <FileDrop
                      className="fileDrops"
                      accept="application/pdf"
                      maxSize={globalConfig.MaxFileSize}
                      required={this.state.required}
                      onDrop={this.fileDrop}
                    >
                      <div
                        className={`upload ${
                          this.context.state.pdfData ? "close" : ""
                        }`}
                      >
                        <Input
                          type="text"
                          placeholder={translateService.t(
                            "common.uploadPdfFile"
                          )}
                          spellCheck="false"
                          value={this.context.state.pdfData?.name || ""}
                          readOnly
                        />
                        {this.context.state.pdfData && (
                          <button
                            className="emtyLink"
                            onClick={(e) => this.emptyFile(e)}
                          ></button>
                        )}
                      </div>
                    </FileDrop>
                  </div>
                  {/*
				  <span className="or">
                    {translateService.t("dashboard.or")}
                  </span>
                  <div className="input-item">
                    <FieldValidation
                      name="url"
                      className="validation-register"
                      rule="url"
                      validation={this.urlValidation}
                      for={this.url}
                    />
                    <div
                      className={`paste ${
                        this.state.doclinkvalid ? "close" : ""
                      }`}
                    >
                      <Input
                        name="url"
                        type="text"
                        placeholder={translateService.t("dashboard.pasetLink")}
                        spellCheck="false"
                        autoComplete="off"
                        value={this.context.state.pdfPath || ""}
                        onChange={(e) => {
                          this.enterUrl(e);
                        }}
                        rules={[{ name: "url" }]}
                        validation={this.urlValidation}
                        ref={(input) => (this.url = input)}
                        onFocus={(e) => this.updateErrorInfo(e)}
                        title={this.context.state.pdfPath}
                      />
                      {this.state.doclinkvalid && (
                        <button
                          className="emtyLink"
                          onClick={() =>{
                            this.setStateProperty({
                              doclinkvalid: false,
                            });
                            this.context.setState({pdfPath: ''});
                          }
                          }
                        ></button>
                      )}
                    </div>
                  </div>
                        */}
                </div>
                <span className="buttons validation">
                  <LoadingButton
                    className="button background-color-two color-white check-button"
                    loading={this.state.isValidationLoading}
                    onClick={() => this.validateDocument(false)}
                  >
                    {translateService.t("common.validation")}
                  </LoadingButton>

                  <LoadingButton
                    className="button background-color-two color-white signature-button"
                    loading={this.state.isSignatureLoading}
                    onClick={() => this.validateDocument(true)}
                  >
                    {translateService.t("dashboard.signature")}
                  </LoadingButton>
                </span>
              </div>

              <div className="accinfoF">
                <span className="account-info">
                  <div className="ai">
                    <span className="account-number">
                      {this.context.state.activeDomain}
                    </span>
                    <span className="account-domain-name">
                      {translateService.t("common.accountDomainName")}
                    </span>
                  </div>
                  {/* <div
                    className={`nd ${this.state.nextPayDate ? "" : "empty"}`}
                  >
                    <span>
                      {this.state.nextPayDate
                        ? translateService.t("common.nextPayDateTitle")
                        : "."}{" "}
                    </span>
                    <span>
                      {dateHelperService.format(
                        this.state.nextPayDate,
                        dateHelperService.serverDateFormat,
                        false,
                        true
                      ) || "."}
                    </span>
                  </div> */}
                </span>
              </div>
            </div>
            {this.renderPending()}
            {this.fetchStarted && this.state.documents.length <= 0 ? (
              <img
                src="./assets/images/black-loading.svg"
                className="content-loader"
              />
            ) : (
              <React.Fragment>
                <div className="items">
                  <Scrollbars
                    onScroll={(e) => this.listScroll(e)}
                    ref={(el) => (this.docList = el)}
                    autoHide
                    className="listScrollbar"
                  >
                    <table id="dashboard" className="for-mobile-table">
                      <tbody>
                        {this.state.documents?.map((doc, index) => (
                          <React.Fragment key={index}>
                            <tr
                              className={`clickable ${index % 2 == 0 && "bg"}`}
                            >
                              <td className="padding">
                                {doc.shared && (
                                  <img
                                    src="../assets/images/upArrowYellow.svg"
                                    className="up"
                                  />
                                )}
                                <span title={doc.docName} className="_3dots-1">
                                  {doc?.header || doc.docName}
                                </span>
                              </td>
                              <td className="padding  mw-500 db">
                                <span className="_3dots-1">
                                  {concateNames(doc?.signers)}
                                </span>
                              </td>
                            </tr>
                            <tr
                              className={`clickable btop ${
                                index % 2 == 0 && "bg"
                              }`}
                            >
                              <td className="padding" colSpan="3">
                                <div className="action-tools">
                                  <div className="padding validationDate">
                                    <span className="nowrap">
                                      {dateHelperService.format(
                                        doc.validationTime,
                                        dateHelperService.dateTimeFormat,
                                        false,
                                        true
                                      )}
                                    </span>
                                  </div>
                                  <img
                                    onClick={() =>
                                      this.getDocumentResult(doc.docExposedId)
                                    }
                                    src="../assets/images/search.svg"
                                  />
                                  <img
                                    onClick={() =>
                                      this.viewDeleteDialog(
                                        doc.docExposedId,
                                        doc.docName
                                      )
                                    }
                                    src="../assets/images/close32smallInner.svg"
                                  />
                                  <img
                                    onClick={() =>
                                      this.viewShareDialog(
                                        doc.docExposedId,
                                        doc.docName
                                      )
                                    }
                                    src="../assets/images/share.svg"
                                  />
                                </div>
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>

                      <thead ref={(el) => (this.mobileListHeader = el)}>
                        <tr>
                          <th className="padding nowrap">
                            {translateService.t("dashboard.filedatabase")}
                          </th>
                          <th className="padding">
                            {translateService.t("dashboard.listOfSignatures")}
                          </th>
                        </tr>
                      </thead>
                    </table>

                    <table id="dashboard" className="for-web-table">
                      <tbody>
                        {this.state.documents?.map((doc, index) => (
                          <tr
                            className={`clickable ${index % 2 == 0 && "bg"}`}
                            key={index}
                          >
                            <td className="padding">
                              {doc.shared && (
                                <img
                                  src="../assets/images/upArrowYellow.svg"
                                  className="up"
                                />
                              )}
                              <span title={doc.docName} className="_3dots-1">
                                {doc?.header || doc.docName}
                              </span>
                            </td>
                            <td className="padding mw-500 db">
                              <span className="_3dots-1 pt-17">
                                {concateNames(doc?.signers)}
                              </span>
                            </td>
                            <td className="padding">
                              <span className="nowrap">
                                {dateHelperService.format(
                                  doc.validationTime,
                                  dateHelperService.dateTimeFormat,
                                  false,
                                  true
                                )}
                              </span>
                            </td>
                            <td>
                              <img
                                onClick={() =>
                                  this.getDocumentResult(doc.docExposedId)
                                }
                                src="../assets/images/search.svg"
                              />
                            </td>
                            <td>
                              <img
                                className={`${doc.visible ? '' : 'actionDisable'}`}
                                onClick={() => {
                                    if(!doc.visible) return;
                                    this.viewDeleteDialog(doc.docExposedId, doc.docName)
                                  }
                                }
                                src="../assets/images/close32smallInner.svg"
                              />
                            </td>
                            <td>
                              <img
                                className={`${doc.visible ? '' : 'actionDisable'}`}
                                onClick={() => {
                                  if(!doc.visible) return;
                                  this.viewShareDialog(doc.docExposedId, doc.docName);
                                }
                                }
                                src="../assets/images/share.svg"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <thead ref={(el) => (this.webListHeader = el)}>
                        <tr>
                          <th className="padding nowrap">
                            {translateService.t("dashboard.filedatabase")}
                          </th>
                          <th className="padding">
                            {translateService.t("dashboard.listOfSignatures")}
                          </th>
                          <th className="padding nowrap">
                            {translateService.t("dashboard.validationDate")}
                          </th>
                          <th>{translateService.t("common.view")}</th>
                          <th>{translateService.t("common.delete")}</th>
                          <th>{translateService.t("common.share")}</th>
                        </tr>
                      </thead>
                    </table>
                  </Scrollbars>
                </div>
              </React.Fragment>
            )}
          </div>
          )}

          <ShareDialog
            isOpen={this.state.shareModal}
            docId={this.state.shareId}
            docName={this.state.documentName}
            onClose={() => this.setState({ shareModal: false })}
          />

          <Modal
            isOpen={this.state.deleteModal}
            fade={false}
            backdrop={false}
            className="modal dashboard-page delete"
            modalClassName="Modal-dialog"
            backdropClassName="backDrop"
            toggle={(e) => {
              this.setState({ deleteModal: false, deleteionId: null });
            }}
          >
            <ModalHeader>
              <span>
                &nbsp;
                <span
                  onClick={() =>
                    this.setState({ deleteModal: false, deleteionId: null })
                  }
                  className="clickable"
                >
                  <img src="../../assets/images/close32.svg" />
                </span>
              </span>
            </ModalHeader>
            <ModalBody>
              <div className="additional color-three">
                <img src="../../assets/images/modal-delete.svg" />
                <div className="title">
                  {translateService
                    .t("common.filedeleteConfirmation")
                    .replace("{0}", this.state.documentName)}
                </div>
                <span className="buttons flexed">
                  <LoadingButton
                    className="button background-color-three color-white"
                    loading={this.state.deleteLoading}
                    onClick={this.delete}
                  >
                    {translateService.t("common.yes")}
                  </LoadingButton>
                  <LoadingButton
                    className="button background-color-one color-white"
                    onClick={() =>
                      this.setState({
                        deleteModal: false,
                        deleteionId: null,
                      })
                    }
                  >
                    {translateService.t("common.no")}
                  </LoadingButton>
                </span>
              </div>
            </ModalBody>
          </Modal>

          <Modal
            isOpen={this.state.documentIsProcessing}
            fade={true}
            toggle={(e) => {
              this.setState({ documentIsProcessing: false });
            }}
          >
            <ModalHeader>
              <span>
                &nbsp;
                <span
                  onClick={() => this.setState({ documentIsProcessing: false })}
                  className="clickable"
                >
                  <img src="../../assets/images/close32.svg" />
                </span>
              </span>
            </ModalHeader>
            <ModalBody>
              <div className="additional color-black">
                <img src="../../assets/images/modal-success.svg" />
                <div className="title">
                  {translateService.t("dashboard.documentIsProcessing")}
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <LoadingButton
                type="button"
                className="button background-color-three color-white"
                onClick={() => this.setState({ documentIsProcessing: false })}
              >
                {translateService.t(`common.close`)}
              </LoadingButton>
            </ModalFooter>
          </Modal>

        </div>
      </React.Fragment>
    );
  }
}

const NotificationResponseTypes = {
  SHARE: "share",
  VAL: "val",
  PROC: "signProc",
};
